import DeleteModal from "@via/components/delete-modal/delete-modal.tsx";
import { ProjectBucketMember } from "common";
import { type FC, useEffect } from "react";
import { useRemoveProjectBucketMember } from "@via/pages/projects/project-bucket.api.tsx";

type DeleteProjectBucketMemberModalProps = {
  projectId: number;
  member: ProjectBucketMember;
  setMemberToBeDeleted: (member: ProjectBucketMember | null) => void;
};

const DeleteProjectBucketMemberModal: FC<
  DeleteProjectBucketMemberModalProps
> = ({ projectId, member, setMemberToBeDeleted }) => {
  const {
    mutateAsync: removeMember,
    isPending: isRemoveMemberLoading,
    isSuccess: isRemoveMemberSuccess,
  } = useRemoveProjectBucketMember();

  const handleRemoveMember = async (): Promise<void> => {
    if (member?.memberEmail) {
      await removeMember({ projectId, memberEmail: member.memberEmail });
    }
  };

  useEffect(() => {
    if (isRemoveMemberSuccess) {
      setMemberToBeDeleted(null);
    }
  }, [isRemoveMemberSuccess]);

  return (
    <DeleteModal
      item={member ? { id: member.id, name: member.memberEmail } : null}
      setItem={setMemberToBeDeleted}
      deleteFunction={handleRemoveMember}
      isLoading={isRemoveMemberLoading}
      title="Remove Project Bucket Member"
      message={name => (
        <>
          Are you sure you want to remove{" "}
          <strong className="font-semibold">{name}</strong> from this project
          bucket?
        </>
      )}
    />
  );
};

export default DeleteProjectBucketMemberModal;
